const capSurveyStatusV1 = [
    { label: 'Vessel is less than 15 years old', value: 'Vessel is less than 15 years old' },
    { label: 'CAP not comply', value: 'CAP not comply' },
    { label: 'CAP Comply', value: 'CAP Comply' }
];

export default capSurveyStatusV1;
